import angular from 'angular';
import { config } from './credit.note.details.config';
import CreditNoteDetails from './credit.note.details.component';
export default angular.module('invision.customercare.customer.billingpayments.creditNote', []).config(config).component('creditNoteDetails', CreditNoteDetails).name;